/*
	RANDOM CHARACTERS
*/
//------------------------------------------------------------
// IMPORT
//------------------------------------------------------------

import Character from './Character.js';

//------------------------------------------------------------
// GWENDOLYN
//------------------------------------------------------------

const RANDOM_CHARACTERS = (() => {
	let cluster = [];
	for (let i = 0; i < 30; i++) {
		const character = new Character({});
		cluster.push(character);
	}
	return cluster;
})();

//------------------------------------------------------------
// EXPORTS
//------------------------------------------------------------

export default RANDOM_CHARACTERS;